import React, { useEffect } from 'react';
import './SideBar.css';
import logoSvg from '../../common/icons/neev_logo.svg';
import uploadSidebarIcon from '../../common/icons/upload_sidebar.png';
import machineRequestSidebarIcon from '../../common/icons/machine_request_sidebar.png';
import networkSidebarIcon from '../../common/icons/network_sidebar.png';
import machineSidebarIcon from '../../common/icons/machine_sidebar.png';
import { CONTAINER_CONST } from '../../common/constant/common-constants';
import { useLocation, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { setActiveIcon, setUserDetails } from '../../modules/actions/action';
import { ROLE } from '../../enum/role';
import { clearAuthSession } from '../../common/utils/StorageUItils';

const getActiveIconFromPath = (pathname) => {
  if (pathname.includes('/system-health') || pathname.includes('/ip-log/health')) {
    return CONTAINER_CONST.SYSTEM_HEALTH_ACTIVE;
  }
  if (pathname.includes('/ip-log')) return CONTAINER_CONST.IP_LOG_UPLOAD_ACTIVE;
  if (pathname.includes('all-system-version-details') || pathname.includes('/ota-upload')) {
    return CONTAINER_CONST.OTA_UPLOAD_ACTIVE;
  }
  if (pathname.includes('/request-callback')) return CONTAINER_CONST.REQUEST_CALLBACK;
  if (pathname.includes('/demo-machine')) return CONTAINER_CONST.DEMO_MACHINE;
  if (pathname.includes('hospital-details')) return CONTAINER_CONST.HOSPITAL_DASHBOARD;
  if (pathname.includes('device-documents')) return CONTAINER_CONST.DEVICE_DOCUMENTS;
  if (pathname.includes('machine-details')) return CONTAINER_CONST.OTA_DETAILS_ACTIVE;
  return null;
};

const IconMachine = ({ active }) => (
  <img
    src={machineSidebarIcon}
    alt=""
    className={`app-sidebar-item-icon${active ? ' app-sidebar-item-icon--active' : ''}`}
  />
);

const IconUpload = ({ active }) => (
  <img
    src={uploadSidebarIcon}
    alt=""
    className={`app-sidebar-item-icon${active ? ' app-sidebar-item-icon--active' : ''}`}
  />
);

const IconMachineRequest = ({ active }) => (
  <img
    src={machineRequestSidebarIcon}
    alt=""
    className={`app-sidebar-item-icon${active ? ' app-sidebar-item-icon--active' : ''}`}
  />
);

const IconNetwork = ({ active }) => (
  <img
    src={networkSidebarIcon}
    alt=""
    className={`app-sidebar-item-icon${active ? ' app-sidebar-item-icon--active' : ''}`}
  />
);

const IconSystemHealth = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path
      d="M3 12h3.2l1.8-4.5L11 17l2.4-6H21"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const IconDevice = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <rect x="4" y="5" width="16" height="11" rx="2" fill="none" stroke="currentColor" strokeWidth="1.8" />
    <path d="M8 20h8" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

const IconHospital = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M6 20V8l6-4 6 4v12H6Z" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
    <path d="M12 10v6M9 13h6" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

const IconDocuments = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M7 4.5h7l5 5V20a1.5 1.5 0 0 1-1.5 1.5H7A1.5 1.5 0 0 1 5.5 20V6A1.5 1.5 0 0 1 7 4.5Z" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
    <path d="M14 4.5V10h5.5M9 13.5h6M9 17h4" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const IconLogout = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M10 7V5a1 1 0 0 1 1-1h7v16h-7a1 1 0 0 1-1-1v-2" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
    <path d="M14 12H4m0 0 3-3m-3 3 3 3" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const SideNavItem = ({ label, active, onClick, children }) => (
  <button
    type="button"
    className={`app-sidebar-item${active ? ' app-sidebar-item--active' : ''}`}
    onClick={onClick}
    title={label}
    aria-label={label}
    aria-current={active ? 'page' : undefined}
  >
    {children}
  </button>
);

const SideBar = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isOpen = false, onClose } = props;

  useEffect(() => {
    const nextActiveIcon = getActiveIconFromPath(location.pathname);
    if (nextActiveIcon) {
      props.setActiveIcon(nextActiveIcon);
    }
  }, [location.pathname, props.setActiveIcon]);

  const { userRole, activeIcon } = props;
  const isAdmin = userRole === ROLE.ADMIN;
  const isProduction = userRole === ROLE.PRODUCTION;
  const isService = userRole === ROLE.SERVICE;

  const go = (path, activate) => {
    navigate(path);
    activate();
    onClose?.();
  };

  const handleLogout = () => {
    localStorage.removeItem('selectedDevice');
    clearAuthSession();
    props.clearUserDetails({ email: '', userRole: '' });
    onClose?.();
    navigate('/');
  };

  return (
    <aside className={`app-sidebar${isOpen ? ' app-sidebar--open' : ''}`}>
      {onClose && isOpen && (
        <button
          type="button"
          className="app-sidebar-close"
          aria-label="Close navigation menu"
          onClick={onClose}
        >
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M6 6l12 12M18 6 6 18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          </svg>
        </button>
      )}
      <div className="app-sidebar-logo">
        <img src={logoSvg} alt="Noccarc" />
      </div>

      <nav className="app-sidebar-nav" aria-label="Main navigation">
        {(isAdmin || isProduction) && (
          <SideNavItem
            label="IP Logs"
            active={activeIcon === CONTAINER_CONST.IP_LOG_UPLOAD_ACTIVE}
            onClick={() => go('/ip-log/', props.activateIpLog)}
          >
            <IconNetwork active={activeIcon === CONTAINER_CONST.IP_LOG_UPLOAD_ACTIVE} />
          </SideNavItem>
        )}

        {(isAdmin || isProduction || isService) && (
          <SideNavItem
            label="Machine"
            active={activeIcon === CONTAINER_CONST.OTA_DETAILS_ACTIVE}
            onClick={() => go('/ota-details/machine-details/', props.activateOtaDetails)}
          >
            <IconMachine active={activeIcon === CONTAINER_CONST.OTA_DETAILS_ACTIVE} />
          </SideNavItem>
        )}

        {(isAdmin || isProduction) && (
          <SideNavItem
            label="System Health"
            active={activeIcon === CONTAINER_CONST.SYSTEM_HEALTH_ACTIVE}
            onClick={() => go('/system-health', props.activateSystemHealth)}
          >
            <IconSystemHealth />
          </SideNavItem>
        )}

        {isAdmin && (
          <SideNavItem
            label="OTA Upload"
            active={activeIcon === CONTAINER_CONST.OTA_UPLOAD_ACTIVE}
            onClick={() => go('/ota-upload/all-system-version-details/', props.activateOtaUpload)}
          >
            <IconUpload active={activeIcon === CONTAINER_CONST.OTA_UPLOAD_ACTIVE} />
          </SideNavItem>
        )}

        {(isAdmin || isService) && (
          <SideNavItem
            label="Request Callback"
            active={activeIcon === CONTAINER_CONST.REQUEST_CALLBACK}
            onClick={() => go('/request-callback/', props.activateRequestCallback)}
          >
            <IconMachineRequest active={activeIcon === CONTAINER_CONST.REQUEST_CALLBACK} />
          </SideNavItem>
        )}

        {(isAdmin || isProduction || isService) && (
          <SideNavItem
            label="Demo Machines"
            active={activeIcon === CONTAINER_CONST.DEMO_MACHINE}
            onClick={() => go('/demo-machine/', props.demoMachine)}
          >
            <IconDevice />
          </SideNavItem>
        )}

        {(isAdmin || isService) && (
          <SideNavItem
            label="Hospital Dashboard"
            active={activeIcon === CONTAINER_CONST.HOSPITAL_DASHBOARD}
            onClick={() => go('/hospital-details/hospital-dashboard/', props.activateHospitalDashboard)}
          >
            <IconHospital />
          </SideNavItem>
        )}

        {(isAdmin || isService) && (
          <SideNavItem
            label="Machine document version"
            active={activeIcon === CONTAINER_CONST.DEVICE_DOCUMENTS}
            onClick={() => go('/device-documents/', props.activateDeviceDocuments)}
          >
            <IconDocuments />
          </SideNavItem>
        )}
      </nav>

      <div className="app-sidebar-footer">
        <SideNavItem label="Logout" active={false} onClick={handleLogout}>
          <IconLogout />
        </SideNavItem>
      </div>
    </aside>
  );
};

const mapStateToProps = (state) => ({
  activeIcon: state.activeIcon.activeSideBarIcon,
  userRole: state.userDetails.userRole,
});

const mapDispatchToProps = (dispatch) => ({
  setActiveIcon: (icon) => dispatch(setActiveIcon(icon)),
  activateOtaDetails: () => dispatch(setActiveIcon(CONTAINER_CONST.OTA_DETAILS_ACTIVE)),
  activateOtaUpload: () => dispatch(setActiveIcon(CONTAINER_CONST.OTA_UPLOAD_ACTIVE)),
  activateIpLog: () => dispatch(setActiveIcon(CONTAINER_CONST.IP_LOG_UPLOAD_ACTIVE)),
  activateSystemHealth: () => dispatch(setActiveIcon(CONTAINER_CONST.SYSTEM_HEALTH_ACTIVE)),
  activateRequestCallback: () => dispatch(setActiveIcon(CONTAINER_CONST.REQUEST_CALLBACK)),
  demoMachine: () => dispatch(setActiveIcon(CONTAINER_CONST.DEMO_MACHINE)),
  activateHospitalDashboard: () => dispatch(setActiveIcon(CONTAINER_CONST.HOSPITAL_DASHBOARD)),
  activateDeviceDocuments: () => dispatch(setActiveIcon(CONTAINER_CONST.DEVICE_DOCUMENTS)),
  clearUserDetails: (data) => dispatch(setUserDetails(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SideBar);
